import { useEffect } from "react";
import { useGetProfileQuery } from "store/slices/profile-api";
import { identify } from "utils/analytics";
import { mixpanelSetPerson } from "utils/mixpanel";

export function useUpdateAnalyticsData() {
    const { data: profile } = useGetProfileQuery();

    useEffect(() => {
        if (profile) {
            identify(profile?.id ?? '');
            // Ideally this should be done from the backend like we do with customer.io. For now, i will leave it here
            mixpanelSetPerson({
                userId: profile?.id ?? undefined,
                email: profile?.email,
                firstName: profile?.firstName ?? undefined,
                lastName: profile?.lastName ?? undefined,
                createdAt: profile?.createdAt ?? undefined,
            });
        }
    }, [profile]);
}
